import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { AnswersDto } from "./CvpGetAnswers";

export const answerQuestion = withNextApi<
  CvpAnswerQuestionResponse,
  CvpAnswerQuestionParameters
>("/cvp/CvpAnswerQuestion", { method: "POST" });

export interface CvpAnswerQuestionResponse extends BackendResponse {
  item: number;
}

export interface CvpAnswerQuestionParameters
  extends NextApiParams,
    AnswersDto {}

export const deleteAnswer = withNextApi<
  CvpDeleteAnswerResponse,
  CvpDeleteAnswersParams
>("/cvp/CvpAnswerQuestion", { method: "DELETE" });

export interface CvpDeleteAnswersParams extends NextApiParams {
  id: number;
}

export interface CvpDeleteAnswerResponse extends BackendResponse {}
